import React from 'react';
import { Link, Typography } from '@mui/material';
import LottieModal from './LottieModal';
import termsAnimation from '../lottie/terms-acceptance.json';

type Props = { busy: boolean; accept: () => void };
export default function TermsAcceptanceModal({ busy, accept }: Props) {
  return (
    <LottieModal open onClose={() => {}} showCloseButton={false} title="Before we proceed" animationData={termsAnimation}
      description="A quick step before you start creating."
      primaryButtonText={busy ? 'Please wait…' : 'Accept and continue'} primaryButtonAction={accept}
      primaryButtonDisabled={busy}>
      <Typography sx={{ color: '#B9BAC5', lineHeight: 1.6 }}>
        Take a moment to read our{' '}
        <Link href="https://thefableapp.com/terms-of-service" target="_blank" rel="noopener noreferrer" color="#D9D9D9">Terms of Service</Link>
        {' '}and{' '}
        <Link href="https://thefableapp.com/privacy" target="_blank" rel="noopener noreferrer" color="#D9D9D9">Privacy Policy</Link>. When you’re ready, accept to continue.
      </Typography>
    </LottieModal>
  );
}
